import axios from "axios";

// Utilidades compartidas por las pantallas del modulo CMMS (Mantenimiento de Equipo Medico).

// Mismo significado que Utils/cmms/constantes.cmms.js del backend.
export const ESTATUS_EQUIPO = [
    { value: 1, label: "Funcional", color: "green" },
    { value: 2, label: "Funcional condicionado", color: "gold" },
    { value: 3, label: "Dañado", color: "red" },
    { value: 4, label: "Baja", color: "default" },
];

export const estatusEquipo = (valor) => ESTATUS_EQUIPO.find((e) => e.value === valor) || { label: "", color: "default" };

// POST a /erp/api/cmms/<ruta> con empresaId incluido.
export const cmmsPost = (props, ruta, body = {}) =>
    axios.post("cmms/" + ruta, { empresaId: props.empresaId, ...body }, { headers: props.headersToken });

export const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

// Para FormItem con Upload: guarda la lista, no el evento.
export const normFile = (e) => (Array.isArray(e) ? e : e && e.fileList);

// fileList de antd Upload -> [{ name, url }] para el backend.
// Nuevos (originFileObj) van en base64; los existentes regresan su ruta relativa.
export const fileListAPayload = async (fileList) => {
    const resultado = [];
    for (const f of fileList || []) {
        if (f.originFileObj) {
            resultado.push({ name: f.name, url: await getBase64(f.originFileObj) });
        } else if (f.urlRelativa || f.url) {
            resultado.push({ name: f.name, url: f.urlRelativa || f.url });
        }
    }
    return resultado;
};

// Sucursales (Cliente.direcciones[]) de un cliente.
export const cargarSucursales = async (props, clienteId) => {
    if (!clienteId) return [];
    try {
        const res = await axios.post(
            "clientes/direccionesCliente",
            { empresaId: props.empresaId, clienteId },
            { headers: props.headersToken }
        );
        return (res.data?.direcciones || []).map((d) => ({
            _id: d._id,
            nombre: d.descripcion || [d.calle, d.numeroCalle].filter(Boolean).join(" ") || "Dirección sin nombre",
        }));
    } catch (error) {
        console.log(error);
        return [];
    }
};

// Valores ya capturados en otros activos para autocompletar modelo / ubicacion / area.
// params: { campo: "modelo" | "ubicacion" | "area", clienteId, direccionId, ubicacion, tipoEquipoId, marcaId, texto }
export const cargarSugerencias = async (props, params) => {
    try {
        const res = await cmmsPost(props, "sugerenciasActivoCMMS", params);
        return res.data.success === 2 ? res.data.sugerencias : [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

export const formatoFecha = (fecha) => {
    if (!fecha) return "";
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" });
};

// Opciones de "Activo / Deshabilitado / Todos" para SegmentedItem.
export const OPCIONES_ESTADO = [
    { label: "Activo", value: 1 },
    { label: "Deshabilitado", value: 2 },
    { label: "Todos", value: 3 },
];

// ─── Servicios y tickets (mismo significado que Utils/cmms/constantes.cmms.js) ─────

export const TIPOS_SERVICIO = [
    { value: 1, label: "Mantenimiento Preventivo" },
    { value: 2, label: "Mantenimiento Correctivo" },
    { value: 3, label: "Diagnóstico" },
    { value: 4, label: "Garantía" },
    { value: 5, label: "Instalación" },
    { value: 6, label: "Calibración" },
    { value: 7, label: "Desinstalación" },
    { value: 8, label: "Revisión" },
    { value: 9, label: "Baja" },
];
export const tipoServicioNombre = (v) => TIPOS_SERVICIO.find((t) => t.value === v)?.label || "";

export const ESTATUS_SERVICIO = [
    { value: 1, label: "Programado", color: "default" },
    { value: 2, label: "En proceso", color: "blue" },
    { value: 3, label: "Concluido", color: "green" },
    { value: 0, label: "Cancelado", color: "red" },
];
export const estatusServicio = (v) => ESTATUS_SERVICIO.find((e) => e.value === v) || { label: "", color: "default" };

export const ESTATUS_TICKET = [
    { value: 1, label: "Recibido", color: "default" },
    { value: 2, label: "Asignado", color: "cyan" },
    { value: 3, label: "En proceso", color: "blue" },
    { value: 4, label: "En espera de autorización", color: "gold" },
    { value: 5, label: "Finalizado", color: "green" },
    { value: 6, label: "Cerrado", color: "purple" },
    { value: 0, label: "Cancelado", color: "red" },
];
export const estatusTicket = (v) => ESTATUS_TICKET.find((e) => e.value === v) || { label: "", color: "default" };

export const PRIORIDADES = [
    { value: 1, label: "Urgente", color: "red" },
    { value: 2, label: "Atención durante el día", color: "orange" },
    { value: 3, label: "Programable", color: "default" },
];
export const prioridad = (v) => PRIORIDADES.find((p) => p.value === v) || { label: "", color: "default" };

export const ORIGENES = { 1: "Manual", 2: "Ticket", 3: "Agenda", 4: "QR", 5: "App" };

export const ETIQUETAS_ANEXO = ["Antes", "Durante", "Después", "Documentación"];

export const formatoFechaHora = (fecha) => {
    if (!fecha) return "";
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleString("es-MX", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

// 125 -> "2 h 05 min"
export const minutosATexto = (min) => {
    if (min === null || min === undefined || isNaN(min)) return "";
    const total = Math.round(Number(min));
    const h = Math.floor(total / 60);
    const m = total % 60;
    return h ? `${h} h ${String(m).padStart(2, "0")} min` : `${m} min`;
};

// URL publica del QR de un activo.
export const urlPublicaActivo = (token) => `${window.location.origin}/activoCMMS/${token}`;

// ─── Contratos y programa (mismo significado que Utils/cmms/calendario.utils.js) ─────

export const ESQUEMAS_COBRO = [
    { value: 1, label: "Cuota fija mensual" },
    { value: 2, label: "Por equipos realizados al mes" },
    { value: 3, label: "Variable" },
];

// Estatus que se muestra de un renglon del programa.
export const ESTATUS_PLAN = {
    porCalendarizar: { label: "Por calendarizar", color: "default", hex: "#9aa7b4" },
    calendarizado: { label: "Calendarizado", color: "blue", hex: "#2f80ed" },
    atrasado: { label: "Atrasado", color: "orange", hex: "#e8833a" },
    enProceso: { label: "En proceso", color: "cyan", hex: "#2fb8d6" },
    realizado: { label: "Realizado", color: "green", hex: "#2e9e6b" },
    noRealizado: { label: "No realizado", color: "red", hex: "#d64545" },
};
export const estatusPlan = (clave) => ESTATUS_PLAN[clave] || { label: "", color: "default", hex: "#9aa7b4" };

export const formatoMoneda = (v) =>
    v === null || v === undefined || v === "" || isNaN(Number(v)) ? "" : `$${Number(v).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatoPorcentaje = (v) => (v === null || v === undefined || isNaN(v) ? "—" : `${Math.round(Number(v) * 1000) / 10}%`);

const ORDINALES = ["1ra", "2da", "3ra", "4ta", "5ta", "6ta", "7ma", "8va", "9na", "10ma", "11va", "12va"];
export const nombreVuelta = (i) => `${ORDINALES[i] || `${i + 1}a`} Vuelta`;

// Divide el periodo del contrato en n vueltas iguales (moment). Devuelve [{ nombre, fechaInicio, fechaFin }].
export const generarVueltas = (moment, inicio, fin, n) => {
    if (!inicio || !fin || !(n > 0)) return [];
    const a = moment(inicio).startOf("day");
    const b = moment(fin).startOf("day");
    const dias = b.diff(a, "days") + 1;
    if (dias < n) return [];
    const vueltas = [];
    for (let i = 0; i < n; i++) {
        const ini = a.clone().add(Math.round((i * dias) / n), "days");
        const finV = i === n - 1 ? b.clone() : a.clone().add(Math.round(((i + 1) * dias) / n) - 1, "days");
        vueltas.push({ nombre: nombreVuelta(i), fechaInicio: ini, fechaFin: finV });
    }
    return vueltas;
};

// Fecha-dia para el backend ("AAAA-MM-DD"): el backend la ancla a mediodia UTC.
export const fechaDiaPayload = (m) => (m ? m.format("YYYY-MM-DD") : null);

// Fecha-dia del backend (mediodia UTC) -> moment del mismo dia, sin corrimiento de zona.
export const momentFechaDia = (moment, f) => (f ? moment(String(f).slice(0, 10), "YYYY-MM-DD") : null);

// Anexos del backend -> forma del componente AnexosCMMS (y de vuelta).
export const anexosAPayload = async (anexos) => {
    const resultado = [];
    for (const a of anexos || []) {
        if (a.originFileObj) {
            resultado.push({ etiqueta: a.etiqueta, nombre: a.nombre || a.name, archivo: { name: a.name, url: await getBase64(a.originFileObj) } });
        } else if (a.archivo?.url) {
            resultado.push({ _id: a._id, etiqueta: a.etiqueta, nombre: a.nombre, archivo: { name: a.archivo.name, url: a.archivo.urlRelativa || a.archivo.url } });
        }
    }
    return resultado;
};
